import { getClient } from '@epilot/compliance-client-internal'
import { useMemo } from 'react'

import { config } from '../configs/api.config'

import { configureClient } from './api-utils'

let client: ReturnType<typeof getClient>

export const getComplianceClient = () => {
  if (!client) {
    client = getClient()

    return configureClient(client, { baseURL: config.COMPLIANCE })
  }

  return client
}

export const useComplianceClient = () =>
  useMemo(() => getComplianceClient(), [])

export type { Components as ComplianceComponents } from '@epilot/compliance-client-internal'
